const BACKEND_API_PATH_RE = /(\/backend\/api\/[^\s?#]+)/i;

/**
 * Shared API gateway until intelligence CloudFront /backend/* → ALB 502 is fixed in AWS.
 * Not stored in .env — revert to same-origin when intelligence.highwatch.ai backend works.
 */
const SHARED_API_GATEWAY_HOST = "insurance.highwatch.ai";

/** Deployed *.highwatch.ai (not localhost). */
export function isHighwatchHosted() {
	if (typeof window === "undefined") return false;
	return /\.highwatch\.ai$/i.test(String(window.location.hostname || ""));
}

function pageHost() {
	return String(typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
}

/**
 * Resolve ALB URLs from env for deployed *.highwatch.ai hosts.
 *
 * - insurance.highwatch.ai → same-origin /backend/api/*
 * - intelligence.highwatch.ai → https://insurance.highwatch.ai/backend/api/* (temporary)
 */
export function rewriteAlbToSameOrigin(configuredUrl, fallbackSameOriginPath = "") {
	const raw = String(configuredUrl || "").trim();
	if (!raw) {
		return fallbackSameOriginPath ? String(fallbackSameOriginPath).replace(/\/+$/, "") : "";
	}

	if (typeof window !== "undefined" && isHighwatchHosted()) {
		const match = raw.match(BACKEND_API_PATH_RE);
		if (match) {
			const path = match[1].replace(/\/+$/, "");
			if (pageHost() === SHARED_API_GATEWAY_HOST) {
				return path;
			}
			return `https://${SHARED_API_GATEWAY_HOST}${path}`;
		}
	}

	return raw.replace(/\/+$/, "");
}

